module.exports = __webpack_public_path__ + "static/media/bg-waist-hip-ratio.da2aa67a.png";